import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the attendanceControl state domain
 */

const selectAttendanceControlDomain = state =>
  state.attendanceControl || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by AttendanceControl
 */

const makeSelectAttendanceData = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.attendanceData,
  );

const selectAttendanceLoading = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.loading,
  );

const selectAttendanceLoadingChange = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.loadingCnahge,
  );

const selectAttendanceError = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.error,
  );

const selectAttendanceControlDeleteSuccessful = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.deleteSuccessful,
  );

const makeSelectAttendanceControl = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate,
  );

const makeSelectCourseDetail = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.courseDetail,
  );
const makeSelectOnDateAbsences = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.onDateAbsences,
  );
const makeSelectOnDateAttendances = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.onDateAttendances,
  );
const makeSelectCourseLoad = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.courseLoading,
  );
const makeSelectCourseError = () =>
  createSelector(
    selectAttendanceControlDomain,
    substate => substate.courseError,
  );


export default makeSelectAttendanceControl;
export {
  selectAttendanceControlDomain,
  makeSelectAttendanceData,
  selectAttendanceLoading,
  selectAttendanceError,
  selectAttendanceControlDeleteSuccessful,
  selectAttendanceLoadingChange,
  // course
  makeSelectCourseDetail,
  makeSelectCourseLoad,
  makeSelectCourseError,
  // on date 
  makeSelectOnDateAbsences,
  makeSelectOnDateAttendances,
};
